// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"358":"31e78104","403":"b95628e2","502":"dec4c112","758":"df038abc","928":"0439a864","945":"d3e8c771"}[chunkId] + ".chunk.css";
};